import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { I18nPipe, SFStorageKeyConstant } from '@boshared';
import { ModalController } from '@ionic/angular';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonItemGroup,
  IonLabel,
  IonList,
  IonSearchbar,
  IonTitle,
  IonToolbar
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { checkmarkCircle, closeOutline } from 'ionicons/icons';
import { ClientInfo, ClientState } from 'projects/bo/src/app/core/services/states/client.service';
import { FarmInfo, FarmState } from 'projects/bo/src/app/core/services/states/farm.service';

export type ClientFarms = {
  client: ClientInfo;
  farms: FarmInfo[];
};

@Component({
  selector: 'app-select-farm',
  templateUrl: './select-farm.component.html',
  styleUrls: ['./select-farm.component.less'],
  imports: [
    IonSearchbar,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonIcon,
    IonContent,
    I18nPipe,
    IonList,
    IonLabel,
    IonItem,
    IonItemGroup,
    CommonModule
  ]
})
export class SelectFarmComponent implements OnInit {
  protected destroyRef = inject(DestroyRef);
  protected modalController = inject(ModalController);
  protected farmState = inject(FarmState);
  protected clientState = inject(ClientState);
  clientFarms: ClientFarms[] = [];
  allFarms: FarmInfo[] = [];

  constructor() {
    addIcons({
      closeOutline,
      checkmarkCircle
    });
  }

  ngOnInit() {
    this.allFarms = JSON.parse(localStorage.getItem(SFStorageKeyConstant.FarmList) || '[]');
    this.onSearchChange({ detail: { value: '' } });
  }

  closeModal() {
    this.modalController.dismiss();
  }

  onSelect(farmId: number) {
    const selectedFarm = this.allFarms.find(farm => farm.farmId == farmId);
    const selectedClient = this.clientFarms.find(client => client.client.clientId == selectedFarm?.clientId)?.client;

    if (selectedFarm && selectedClient) {
      // Set selected farm and client
      this.clientState.setState(selectedClient);
      this.farmState.setState(selectedFarm);

      // Set selected farm list
      this.farmState.initFarmList();
    }
    this.closeModal();
  }

  onSearchChange(farmName: any) {
    const searchFarm = farmName.detail.value.toLowerCase();

    const clients = this.clientState.getClientList();

    this.clientFarms = clients
      .map(client => {
        const clientFarms = this.allFarms.filter(
          farm => farm.clientId == client.clientId && (searchFarm === '' || farm.farmName.toLowerCase().includes(searchFarm))
        );
        return { client: client, farms: clientFarms };
      })
      .filter(group => group.farms.length > 0);
  }
}
